// Webpack
import "bootstrap";
import Swiper from "swiper/bundle";
import { Luminous, LuminousGallery } from "luminous-lightbox";
import AOS from "aos";
import Alpine from "alpinejs";
import $ from "jquery";
import "jquery-match-height";
import objectFitImages from "object-fit-images";
// import objectFitImages from 'object-fit-images';
// import { throttle } from "lodash";
const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

window.Alpine = Alpine;

const mobileNavigation = document.querySelector(".mobile-navigation");

Alpine.store("mobileNavigation", {
  isOpen: false,
  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      disableBodyScroll(mobileNavigation);
    } else {
      enableBodyScroll(mobileNavigation);
    }
  },
});

Alpine.data("scrollToTop", () => ({
  show: false,
  scroll() {
    scrollTo({ top: 0, behavior: "smooth" });
  },
}));

Alpine.store("fixedFooter", {
  open: true,
  hideFooter() {
    this.open = false;
  },
  showFooter() {
    if (window.innerWidth >= 992) {
      return;
    }
    this.open = true;
  },
});

window.addEventListener("DOMContentLoaded", () => {
  // Front-page
  // Hero
  if (document.body.classList.contains("home")) {
    const heroSwiper = new Swiper(".hero-swiper", {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });

    $(".privilege-item-text").matchHeight({
      byRow: false,
    });
    $(".mitsuiya-sns h3").matchHeight({
      byRow: false,
    });
  }

  // 写真de成人式
  if (document.body.classList.contains("page_photo")) {
    const photoSwiper = new Swiper(".photo-swiper", {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }

  // お問い合わせ
  if (document.body.classList.contains("page_contact")) {
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        location = "./thanks-contact";
      },
      false
    );
  }

  // 資料請求
  if (document.body.classList.contains("page_catalog")) {
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        location = "./thanks-catalog";
      },
      false
    );
  }

  // 来店予約
  if (document.body.classList.contains("page_reserve")) {
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        location = "./thanks-reserve";
      },
      false
    );
  }

  // AOS
  AOS.init();

  // Alpine.js
  window.Alpine = Alpine;
  Alpine.start();

  // privilege
  $(".mh-title-1").matchHeight({
    byRow: false,
  });
  $(".mh-item-privilege-1").matchHeight({
    byRow: false,
  });
  $(".mh-item-privilege-2").matchHeight({
    byRow: false,
  });
  $(".mh-item-privilege-3").matchHeight({
    byRow: false,
  });

  // Object-fit
  let $ofiImages = $("img.object-fit-img-cover");
  objectFitImages($ofiImages);

  // Ajax
  const readMoreButton = document.querySelector(`[data-read-more-button]`);
  if (!readMoreButton) {
    return;
  }
  let url = `${window.homeUrl}/wp-content/themes/mitsuiya/template-parts/ajax-item-${window.postType}.php`;
  // 最初に表示されている記事数 window.postNumNow が未定義の場合はデフォルト値として12
  let postNumNow = window.postNumNow || 9;
  // 追加する記事数 window.postNumAdd が未定義の場合はデフォルト値として12
  let postNumAdd = window.postNumAdd || 9;
  if (postNumNow >= window.postCountJson) {
    readMoreButton.classList.add("d-none");
  }
  readMoreButton.addEventListener("click", () => {
    $.ajax({
      type: "POST",
      url: url,
      data: {
        post_num_now: postNumNow,
        post_num_add: postNumAdd,
        post_ids: window.postIdsJson,
      },
      success: (response) => {
        $(".items-row").append(response);
        postNumNow += postNumAdd;
        if (postNumNow >= window.postCountJson) {
          readMoreButton.classList.add("d-none");
        }
      },
    });
  });

  // Luminous
  const tokusenImages = document.querySelectorAll(".item-tokusen a");
  tokusenImages.forEach((img) => {
    new Luminous(img);
  });
});
